import {Relation} from "./Relation";
import {ProjectRelation} from "./ProjectRelation";
import {ProjectNote} from "./ProjectNote";
import {ProjectSettings} from "./ProjectSettings";

export const projectStatusOptions = {
  'Aanvraag': 'Aanvraag',
  'Verstuurd': 'Verstuurd',
  'Opdracht': 'Opdracht',
  'Showroom': 'Showroom',
  'Vervallen': 'Vervallen',
  'Afgerond': 'Afgerond',
  'Anders': 'Anders',
}
export type ProjectStatus = keyof typeof projectStatusOptions

export class Project {
  constructor(
    public readonly id: string,
    public readonly proteus_id: string,
    public readonly projectNumber: string,
    public readonly projectMemo: string,
    public readonly description: string,
    public readonly primaryContactId: string|null,
    public readonly accountManagerId: string|null,
    public readonly type: string,
    public readonly status: ProjectStatus|null,
    public readonly deliveryName: string|null,
    public readonly deliveryAddressStreetname: string|null,
    public readonly deliveryAddressHouseNumber: string|null,
    public readonly deliveryAddressHouseNumberAddition: string|null,
    public readonly deliveryZipCode: string|null,
    public readonly deliveryCity: string|null,
    public readonly deliveryPhone: string|null,
    public readonly deliveryEmail: string|null,
    public readonly floorColor: string|null,
    public readonly createdAt: Date,
    public readonly updatedAt: Date,
    public readonly relations?: Relation[],
    public readonly projectRelations?: ProjectRelation[],
    public readonly projectNotes?: ProjectNote[],
  ) {
  }

  static fromJson(json: any): Project {
    return new Project(
      String(json['id']),
      String(json['proteus_id']),
      json['project_number'],
      json['project_memo'],
      json['description'],
      json['primary_contact_id'],
      json['account_manager_id'],
      json['type'],
      json['status'] as ProjectStatus|null,
      json['delivery_name'],
      json['delivery_address_streetname'],
      json['delivery_address_house_number'],
      json['delivery_address_house_number_addition'],
      json['delivery_zipcode'],
      json['delivery_city'],
      json['delivery_phone'],
      json['delivery_email'],
      json['floor_color'] ? json['floor_color'] : null,
      new Date(json['created_at']),
      new Date(json['updated_at']),
      json['relations'] ? json['relations'].map((r: any) => Relation.fromJson(r)) : undefined,
      json['project_relations'] ? json['project_relations'].map((pr: any) => ProjectRelation.fromJson(pr)) : undefined,
      json['project_notes'] ? json['project_notes'].map((pn: any) => ProjectNote.fromJson(pn)) : undefined,
    );
  }

  get deliveryAddressLine(): string {
    return `${this.deliveryAddressStreetname ?? ''} ${this.deliveryAddressHouseNumber ?? ''}${this.deliveryAddressHouseNumberAddition ?? ''}`
  }
}